import React, { useEffect, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [menuActive, setMenuActive] = useState(false);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  const location = useLocation();

  // Handle scroll (mil-top-panel active)
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Handle window resize
  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const toggleMenu = () => setMenuActive(!menuActive);

  const handleSubmenuClick = (e) => {
    if (windowWidth < 1200) e.preventDefault();
  };

  // 🔥 This handles NavLink click: scrolls up + closes menu if mobile
  const handleNavLinkClick = () => {
    window.scrollTo({ top: 0, behavior: "smooth" }); // scroll to top
    if (windowWidth < 1200) {
      setMenuActive(false); // close mobile menu
    }
  };

  const isOfertaActive = location.pathname.startsWith("/budownictwo");
  const isHomeActive = location.pathname === "/";
  const isProjectActive = location.pathname === "/realizacje";
  const isContactActive = location.pathname === "/kontakt";

  return (
    <header>
      <div className={`mil-top-panel ${isScrolled ? "mil-active" : ""}`}>
        <div className="container-fluid">
          <div className="mil-top-panel-content">
            <NavLink to="/" className="mil-logo" onClick={handleNavLinkClick}>
              <img
                src="assets/images/logo/logo-light.png"
                alt="Logo"
                style={{ width: "130px", paddingLeft: "20px" }}
              />
            </NavLink>

            <div className={`mil-navigation ${menuActive ? "mil-active" : ""}`}>
              <nav>
                <ul>
                  <li>
                    <NavLink
                      to="/"
                      end
                      className={`${isHomeActive ? "mil-active" : ""}`}
                      onClick={handleNavLinkClick}
                    >
                      Home
                    </NavLink>
                  </li>

                  <li
                    className={`mil-has-children ${
                      isOfertaActive ? "mil-active" : ""
                    }`}
                  >
                    <a href="/" onClick={handleSubmenuClick}>
                      OFERTA
                    </a>
                    <ul>
                      <li>
                        <NavLink
                          to="/budownictwo-mieszkalne"
                          onClick={handleNavLinkClick}
                        >
                          BUDOWNICTWO MIESZKALNE
                        </NavLink>
                      </li>
                      <li>
                        <NavLink
                          to="/budownictwo-wielorodzinne"
                          onClick={handleNavLinkClick}
                        >
                          BUDOWNICTWO WIELORODZINNE
                        </NavLink>
                      </li>
                      <li>
                        <NavLink
                          to="/budownictwo-uslugowo-przemyslowe"
                          onClick={handleNavLinkClick}
                        >
                          BUDOWNICTWO USŁUGOWO-PRZEMYSŁOWE
                        </NavLink>
                      </li>
                    </ul>
                  </li>

                  <li>
                    <NavLink
                      to="/realizacje"
                      className={`${isProjectActive ? "mil-active" : ""}`}
                      onClick={handleNavLinkClick}
                    >
                      REALIZACJE
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      to="/kontakt"
                      className={`${isContactActive ? "mil-active" : ""}`}
                      onClick={handleNavLinkClick}
                    >
                      KONTAKT
                    </NavLink>
                  </li>
                </ul>
              </nav>
            </div>

            <div className="mil-top-panel-buttons">
              <div className="mil-menu-btn" onClick={toggleMenu}>
                <span></span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
